import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import YellowStripe from '../components/YellowStripe';
import Services from '../components/Services';
import Vorteile from '../components/Vorteile';
import About from '../components/About';
import BookingSection from '../components/BookingSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="bg-charcoal min-h-screen">
      <Header />
      <Hero />
      <YellowStripe />
      <Services />
      <YellowStripe />
      <Vorteile />
      <YellowStripe />
      <About />
      <BookingSection />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
